// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: block;
    font-family: system-ui, sans-serif;
}

.layout {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    min-height: 100%s;
}

.panel {
    flex: 1;
    background: var(--panel);
    ;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    min-height: 100%;
}

h2 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
}

.list {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-height: 100%;
    padding: 0.5rem;
    /* // border: 2px dashed #ccc; */
    border-radius: 0.3rem;
    /* // background: white; */
}

.item {
    --c: #3b82f6;
    background: linear-gradient(180deg, #111827, #0b1220);
    border: 1px solid #334155;
    color: #e5e7eb;
    border-radius: 12px;
    min-height: 28px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: grab;
    user-select: none;
    touch-action: none;
    position: relative;
    transition: box-shadow .12s ease, background .12s ease;

}

.item.dragging {
    cursor: grabbing;
    transform: scale(1.05);
    opacity: 0.8;
}

.item.ok {
    outline: 2px solid #22c55e;
}

.item.bad {
    outline: 2px solid #ef4444;
}

.marker {
    height: 0.3rem;
    background: #3b82f6;
    border-radius: 0.3rem;
    margin: 0.2rem 0;
}

.hint {
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.5rem;
}

.controls {
    margin-top: 1rem;
    display: flex;
    gap: 0.5rem;
}

button.action {
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 0.3rem;
    padding: 0.4rem 0.8rem;
    cursor: pointer;
}

button.action:hover {
    background: #2563eb;
}

.dropTarget {
    outline: 2px dashed #3b82f6;
    outline-offset: 6px;
}

.panel {
    position: sticky;
    top: 1rem;
    /* distance depuis le haut du viewport */
    align-self: flex-start;
}

@media (max-width:820px) {
    .layout {
        grid-template-columns: 1fr;
        flex-direction: column;
    }

    .panel {
        min-height: auto;
        position: relative;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/line-list/line-list.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,wBAAwB;;IAExB,aAAa;IACb,qBAAqB;IACrB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,qDAAqD;IACrD,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sDAAsD;;AAE1D;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":[":host {\n    display: block;\n    font-family: system-ui, sans-serif;\n}\n\n.layout {\n    display: flex;\n    gap: 2rem;\n    align-items: flex-start;\n    min-height: 100%s;\n}\n\n.panel {\n    flex: 1;\n    background: var(--panel);\n    ;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    min-height: 100%;\n}\n\nh2 {\n    font-size: 1.1rem;\n    margin-bottom: 0.5rem;\n}\n\n.list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    min-height: 100%;\n    padding: 0.5rem;\n    /* // border: 2px dashed #ccc; */\n    border-radius: 0.3rem;\n    /* // background: white; */\n}\n\n.item {\n    --c: #3b82f6;\n    background: linear-gradient(180deg, #111827, #0b1220);\n    border: 1px solid #334155;\n    color: #e5e7eb;\n    border-radius: 12px;\n    min-height: 28px;\n    padding: 10px 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: grab;\n    user-select: none;\n    touch-action: none;\n    position: relative;\n    transition: box-shadow .12s ease, background .12s ease;\n\n}\n\n.item.dragging {\n    cursor: grabbing;\n    transform: scale(1.05);\n    opacity: 0.8;\n}\n\n.item.ok {\n    outline: 2px solid #22c55e;\n}\n\n.item.bad {\n    outline: 2px solid #ef4444;\n}\n\n.marker {\n    height: 0.3rem;\n    background: #3b82f6;\n    border-radius: 0.3rem;\n    margin: 0.2rem 0;\n}\n\n.hint {\n    font-size: 0.85rem;\n    color: #666;\n    margin-top: 0.5rem;\n}\n\n.controls {\n    margin-top: 1rem;\n    display: flex;\n    gap: 0.5rem;\n}\n\nbutton.action {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    border-radius: 0.3rem;\n    padding: 0.4rem 0.8rem;\n    cursor: pointer;\n}\n\nbutton.action:hover {\n    background: #2563eb;\n}\n\n.dropTarget {\n    outline: 2px dashed #3b82f6;\n    outline-offset: 6px;\n}\n\n.panel {\n    position: sticky;\n    top: 1rem;\n    /* distance depuis le haut du viewport */\n    align-self: flex-start;\n}\n\n@media (max-width:820px) {\n    .layout {\n        grid-template-columns: 1fr;\n        flex-direction: column;\n    }\n\n    .panel {\n        min-height: auto;\n        position: relative;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
